export interface SelectStrategy<T> {
  select(value: T, current?: T): T;
  unselect(value: T, current?: T): T;
}
